import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href: string;
  external?: boolean;
  variant?: 'primary' | 'outline';
  size?: 'default' | 'large';
  fullWidth?: boolean;
  className?: string;
  ariaLabel?: string;
}
export function CTAButton({
  children,
  href,
  external = false,
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  className = '',
  ariaLabel
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const opensExternally = external && !isAnchor;
  const base = 'group relative inline-flex items-center justify-center gap-2 overflow-hidden font-display font-extrabold uppercase tracking-wide text-center rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FF7A00]/40 active:translate-y-[1px]';
  const variants: Record<string, string> = {
    primary: 'bg-[#FF7A00] text-[#111111] border border-[#FFA24D]/60 shadow-[0_0_0_1px_rgba(216,154,61,0.35),0_14px_38px_-12px_rgba(255,122,0,0.85),0_0_28px_-6px_rgba(255,122,0,0.55)] hover:bg-[#FF8C1A] hover:-translate-y-[2px] hover:shadow-[0_0_0_1px_rgba(216,154,61,0.5),0_18px_46px_-12px_rgba(255,122,0,1),0_0_40px_-6px_rgba(255,122,0,0.7)]',
    outline: 'border border-[#D89A3D]/50 text-[#F8F3EA] hover:border-[#FF7A00] hover:text-[#FF7A00] bg-transparent'
  };
  const sizes: Record<string, string> = {
    default: 'px-6 min-h-[52px] py-3 text-sm md:text-base',
    large: 'px-8 min-h-[60px] py-4 text-base md:text-lg leading-tight'
  };
  const classes = `${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : 'w-full sm:w-auto'} ${className}`;
  const content = <>
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-399" data-mp="39in57938vw5u">
        {children}
      </span>
      {variant === 'primary' && <span aria-hidden="true" className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 -skew-x-12 bg-white/25 opacity-0 transition-all duration-500 group-hover:left-[110%] group-hover:opacity-100" data-id="element-400" data-mp="2h0rl5k0m772f" />}
    </>;
  if (opensExternally) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} aria-label={ariaLabel} data-id="element-401" data-mp="fxqq468pz1dd">
        {content}
      </a>;
  }
  return <a href={href} className={classes} aria-label={ariaLabel} data-id="element-402" data-mp="kva4r79bxg5u">
      {content}
    </a>;
}